import { requireModule } from '../../auth/guards';
import { MODULES } from '../../auth/permissions';
import MyWorkPage from './pages/MyWorkPage';
import ReassignmentsPage from './pages/ReassignmentsPage';
import TaskDetailPage from './pages/TaskDetailPage';
import TaskListPage from './pages/TaskListPage';
import TimesheetPage from './pages/TimesheetPage';
import WorkloadPage from './pages/WorkloadPage';

export const taskRoutes = [
  { path: '/tasks', element: <TaskListPage />, handle: { breadcrumb: 'Tasks' }, loader: requireModule(MODULES.TASKS) },
  // Declared before `/tasks/:id` so "reassignments" is not read as an id.
  { path: '/tasks/reassignments', element: <ReassignmentsPage />, handle: { breadcrumb: 'Reassignments' }, loader: requireModule(MODULES.REASSIGNMENTS) },
  { path: '/tasks/:id', element: <TaskDetailPage />, handle: { breadcrumb: 'Task' }, loader: requireModule(MODULES.TASKS) },
  { path: '/my-work', element: <MyWorkPage />, handle: { breadcrumb: 'My Work' }, loader: requireModule(MODULES.MY_WORK) },
  { path: '/timesheet', element: <TimesheetPage mode='mine' />, handle: { breadcrumb: 'My Timesheet' }, loader: requireModule(MODULES.MY_TIMESHEET) },
  { path: '/team-timesheets', element: <TimesheetPage mode='team' />, handle: { breadcrumb: 'Team Timesheets' }, loader: requireModule(MODULES.TEAM_TIMESHEETS) },
  { path: '/workload', element: <WorkloadPage />, handle: { breadcrumb: 'Workload' }, loader: requireModule(MODULES.WORKLOAD) },
];
